import { authFormPost, authGet, authPost, doPost } from "../redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_DOMAIN;

export function getMember1(queryParams) {
  return authGet(`${baseUrl}/Member1.ashx`, queryParams);
}

export function postMember1(queryParams) {
  return authPost(`${baseUrl}/Member1.ashx`, queryParams);
}

export function getMember2(queryParams) {
  return authGet(`${baseUrl}/Member2.ashx`, queryParams);
}

export function postMember2(queryParams) {
  return authPost(`${baseUrl}/Member2.ashx`, queryParams);
}

export function getMember3(queryParams) {
  return authGet(`${baseUrl}/Member3.ashx`, queryParams);
}

export function postMember3(queryParams, isDemo) {
  return authPost(`${baseUrl}/Member3.ashx`, queryParams, undefined, isDemo);
}

export function getMember4(queryParams) {
  return authGet(`${baseUrl}/Member4.ashx`, queryParams);
}

export function postMember4(queryParams) {
  return authPost(`${baseUrl}/Member4.ashx`, queryParams);
}

export function postMember6(queryParams) {
  return authPost(`${baseUrl}/Member6.ashx`, queryParams);
}

export function postMember7(queryParams, isDemo) {
  return authPost(`${baseUrl}/Member7.ashx`, queryParams, undefined, isDemo);
}

export function postMember8(queryParams, isDemo) {
  return authPost(`${baseUrl}/Member8.ashx`, queryParams, undefined, isDemo);
}

export function postMemberVip1(queryParams) {
  return authPost(`${baseUrl}/MemberVIP1.ashx`, queryParams);
}

export function getMobile1(queryParams) {
  return authGet(`${baseUrl}/Mobile1.ashx`, queryParams);
}

export function postMobile1(queryParams) {
  return authPost(`${baseUrl}/Mobile1.ashx`, queryParams);
}

export function postMobile2(queryParams) {
  return authPost(`${baseUrl}/Mobile2.ashx`, queryParams);
}

export function postMobileA1(queryParams) {
  return doPost(`${baseUrl}/MobileA1.ashx`, queryParams);
}

export function postMobile3(queryParams) {
  return authPost(`${baseUrl}/Mobile3.ashx`, queryParams);
}

export const atmDepositRequest = (queryParams) => {
  return authFormPost(
    `${window.location.protocol}//${process.env.REACT_APP_API_DOMAIN}/deposit.php`,
    queryParams
  );
};

export const addCommentRequest = (queryParams) => {
  return authFormPost(
    `${window.location.protocol}//${process.env.REACT_APP_MEDIA_DOMAIN}/api/memberAddComment.php`,
    queryParams
  );
};
